export const STATS_LOADING = "STATS_LOADING";
export const STATS_LOADED = "STATS_LOADED";
export const STATS_FAILED = "STATS_FAILED";